<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">      
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
          <el-breadcrumb-item>商家列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">            
          <el-form-item>
            <el-button type="primary" size="small" class="el-icon-circle-plus-outline" v-on:click="AddBusiness" >新增</el-button>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="商家名称" size="small" clearable v-model="queryParam.name"></el-input>
          </el-form-item>
          <el-form-item >
            <el-date-picker
              v-model="queryParam.date"
              size="small" 
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"                
              end-placeholder="结束日期"
              @change="dateSelect"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="business" style="width: 100%">
          <el-table-column  fixed   prop="Name" :show-overflow-tooltip="true" label="名称" width="200"> </el-table-column>
          <el-table-column  prop="LinkMan"  label="联系人" > </el-table-column>
          <el-table-column  prop="Mobile"  label="联系电话" > </el-table-column>
          <el-table-column  prop="PointPayLimit"  label="积分支付比例">
            <template slot-scope="scope">
              <p> {{ scope.row.PointPayLimit }}%</p>
            </template>
          </el-table-column>
          <!-- <el-table-column  prop="BossAccount"  label="老板账号"> </el-table-column>
          <el-table-column  prop="CustomerService"  label="客服账号"> </el-table-column> -->
          <el-table-column  prop="RegisterTime"  label="注册时间" :formatter="dateFormat"> </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="EditBusiness(scope.row.Id)" type="text" size="small">编辑</el-button>
              <el-button @click.native.prevent="SetFinancial(scope.row.Id)" type="text" size="small"> 收款</el-button>
              <el-button @click.native.prevent="DeleteRow(scope.row)"  type="text" size="small"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        business:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:'registertime desc',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddBusiness:function(){
        this.$router.push('addMerchant')
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Merchant/index',
          headers:{
            Authorization: sessionStorage.getItem('token')
          },
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.business = resp.data.merchants
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      EditBusiness(id){
        this.$router.push({
          name:'editMerchant',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      SetFinancial(id) {
        this.$router.push({
          name:'merchantFinancial',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      },
      dateSelect(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该商家吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Merchant/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>